import React from 'react';
import { useBrandingColors } from '../../hooks/useBrandingColors';
import { ReactComponent as GripVerticalIcon } from '../../assets/icons/grip-vertical.svg';
import { ReactComponent as DeleteBinLineIcon } from '../../assets/icons/delete-bin-line.svg';

interface CompanyQuestionCardProps {
  questionNumber: number;
  totalQuestions: number;
  question: string;
  answer: string;
  onQuestionChange: (value: string) => void;
  onAnswerChange: (value: string) => void;
  onDelete: () => void;
}

export function CompanyQuestionCard({
  questionNumber,
  totalQuestions,
  question,
  answer,
  onQuestionChange,
  onAnswerChange,
  onDelete,
}: CompanyQuestionCardProps) {
  const colors = useBrandingColors();

  return (
    <div className="bg-[#ffffff] rounded-[12px] p-4 w-full">
      <div className="flex items-center gap-[10px] mb-4">
        <div className="cursor-move">
          <GripVerticalIcon className="w-6 h-6" />
        </div>
        <h4 className="text-[20px] font-medium text-[#0a0d14] leading-[28px]">
          Вопрос {questionNumber} из {totalQuestions}
        </h4>
      </div>

      <div className="mb-4">
        <textarea
          value={question}
          onChange={(e) => onQuestionChange(e.target.value)}
          placeholder="Какие преимущества предлагает наша компания?"
          className="w-full h-[120px] py-[14px] px-[24px] border border-[#e2e4e9] rounded-[16px] text-[16px] resize-none outline-none focus:ring-0"
          onFocus={(e) => { e.currentTarget.style.boxShadow = `0 0 0 2px ${colors.primary}33`; }}
          onBlur={(e) => { e.currentTarget.style.boxShadow = 'none'; }}
        />
      </div>

      <div className="mb-4">
        <textarea
          value={answer}
          onChange={(e) => onAnswerChange(e.target.value)}
          placeholder="Мы предлагаем конкурентную заработную плату, гибридный или удаленный формат работы. Доступ к профессиональному обучению, медицинскую страховку и другие социальные пакеты."
          className="w-full h-[120px] py-[14px] px-[24px] border border-[#e2e4e9] rounded-[16px] text-[16px] resize-none outline-none focus:ring-0"
          onFocus={(e) => { e.currentTarget.style.boxShadow = `0 0 0 2px ${colors.primary}33`; }}
          onBlur={(e) => { e.currentTarget.style.boxShadow = 'none'; }}
        />
      </div>

      <div className="flex items-center justify-end px-6">
        <button
          type="button"
          onClick={onDelete}
          className="flex items-center gap-1 transition-colors text-[14px] font-normal"
          style={{ color: colors.primary }}
        >
          <DeleteBinLineIcon className="w-4 h-4" style={{ color: colors.primary }} />
          Удалить
        </button>
      </div>
    </div>
  );
}
